export const cms = {
  url: process.env.REACT_APP_CMS_URL || 'http://localhost:8055'
}